module.exports = __webpack_public_path__ + "static/media/5-active.05d0d1b2.svg";